import { LearningCenterArticleLink } from './LearningCenterArticleLink.component';

export default { LearningCenterArticleLink };
